(function () {
    var templateUrl = require('./search-result-post.html');

    angular.module('far.search').directive('searchResultPost', searchResultPost);

    function searchResultPost() {
        return {
            templateUrl: templateUrl
        };
    }
})();
